import { Component, Fragment } from 'react';
import Modal from '../modal';
import { CDN_CLRSAVE_URL, MONTH_TEXT_MAP } from '../../constants';
import { Router } from '../../configs/routes';
import { getFormattedDate } from '../../utils/commonUtils';
import { trackAction } from '../../utils/trackActions';

interface Props {
  investmentType: string;
  amount: number;
  url: any;
  sipDate: string;
  firstPaymentDate: string;
}

interface State {
  sipDate: string;
  firstPaymentDate: string;
}

const date = new Date();

class MandateSuccessScheduleModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      sipDate: '',
      firstPaymentDate: '',
    };
  }

  private getSipNextMonthAndYear = (firstPaymentDate: string) => {
    const firstPaymentMonth = parseInt(firstPaymentDate.slice(5, 7), 10);
    const currentMonth = firstPaymentMonth || date.getMonth() + 1;
    const currentYear = date.getFullYear();
    const nextSipMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const sipStartYear =
      nextSipMonth < currentMonth ? currentYear + 1 : currentYear;

    return {
      nextSipMonth,
      sipStartYear,
    };
  };

  public componentDidMount() {
    const { url } = this.props;
    const { query } = url;
    if (query) {
      const { sipDate, firstPaymentDate } = query;
      this.setState({
        sipDate,
        firstPaymentDate,
      });
    }
  }

  public goToDashboard = () => {
    trackAction('click', 'schedule-payment-flow', 'go-to-dashboard');
    Router.pushRoute('/save/dashboard/portfolio');
  };

  public render() {
    const { investmentType, amount, sipDate, firstPaymentDate } = this.props;
    return (
      <Modal fullScreen width="800px" hideHeader>
        <div className="center pt20 pb60 height">
          <div>
            <img
              src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1571732549_checked1.svg`}
              alt="success"
              className="mb10"
            />
          </div>
          <div className="bold mb10 text--xlg">Congratulations!</div>
          <div className="mb30">Your mandate setup has been successful.</div>

          {investmentType === 'SIP_MF' ? (
            <Fragment>
              <div className="text--normal mb10">
                Your first SIP of ₹{Number(amount).toLocaleString('en-IN')} is
                scheduled on {getFormattedDate(firstPaymentDate, true)}
              </div>
              <div className="text--normal mb30">
                Your subsequent SIP’s will be made on {sipDate}th of every
                month, beginning from {sipDate}th{' '}
                {
                  MONTH_TEXT_MAP[
                    this.getSipNextMonthAndYear(firstPaymentDate).nextSipMonth
                  ]
                }
                , {this.getSipNextMonthAndYear(firstPaymentDate).sipStartYear}.
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="text--normal mb10">
                Your payment of ₹{Number(amount).toLocaleString('en-IN')} is
                scheduled on {getFormattedDate(firstPaymentDate, true)}
              </div>
              <div className="text--normal mb30">
                Applicable NAV will be subject to payment realization by AMC
              </div>
            </Fragment>
          )}

          <button
            className="btn btn-blue btn-small cursor--pointer"
            onClick={this.goToDashboard}
          >
            GO TO DASHBOARD
          </button>
        </div>
        <style>
          {`
            @media screen and (min-width: 768.1px) {
              .height{
                height: 385px;
              }
            }
            `}
        </style>
      </Modal>
    );
  }
}

export default MandateSuccessScheduleModal;



// WEBPACK FOOTER //
// ./components/mandate/mandateSuccessScheduleModal.tsx